import React, { useEffect, useState } from "react";
import HeroSection from "./HeroSection";
import Discover from "./Discover";
import Testinomial from "./Testinomial";
import { getMetadataByPage } from "../../API/Api";
import { Helmet } from "react-helmet-async";

const Employers = () => {
  const [metadata, setMetadata] = useState(null);

  useEffect(() => {
    const fetchMetadata = async () => {
      const data = await getMetadataByPage("employers");
      setMetadata(data);
    };
    fetchMetadata();
  }, []);

  return (
    <>
      {metadata && (
        <Helmet>
          <title>{metadata?.title || "Anaxistech"}</title>
          <meta
            name="description"
            content={metadata?.description || "Default description"}
          />
          <meta
            name="keywords"
            content={metadata?.keywords || "tech, services"}
          />
          <meta
            property="og:title"
            content={metadata?.ogTitle || metadata?.title || "Anaxistech"}
          />
          <meta
            property="og:description"
            content={
              metadata?.ogDescription ||
              metadata?.description ||
              "Default description"
            }
          />
          <meta
            property="og:image"
            content={metadata?.ogImage || "/default-image.png"}
          />
        </Helmet>
      )}
      <HeroSection />
      <Discover />
      <Testinomial />
      <style jsx>
        {`
        .form-container-employee select,
            .form-container-employee input {
              width: 100% !important;
              margin-bottom: 0 !important;
              border-radius: 8px !important;
              border: 1px solid purple;
              background-color: #d6d6d6 !important;
            }
          /* Popup Modal */
          .modal-overlay {
            position: fixed;
            inset: 0;
            background: rgba(0, 0, 0, 0.65);
            display: flex;
            align-items: center;
            justify-content: center;
            z-index: 1050;
          }

          .modal-content {
            background: #fff;
            border-radius: 10px;
            padding: 20px;
            width: 90%;
            max-width: 500px;
            position: relative;
            animation: fadeIn 0.3s ease-in-out;
          }

          .close-btn {
            position: absolute;
            top: 12px;
            right: 15px;
            background: none;
            border: none;
            font-size: 20px;
            cursor: pointer;
          }

          /* Smooth popup */
          @keyframes fadeIn {
            from {
              opacity: 0;
              transform: scale(0.9);
            }
            to {
              opacity: 1;
              transform: scale(1);
            }
          }
         
          /* 📱 Mobile View Adjustments */
          @media (max-width: 767px) {
            .employee-hero-btn {
              display: block !important;
            }
              .popup-button{
              display: block !important;
              }

            /* Hero Section form stack */
            .form-container-employee {
              width: 100% !important;
              padding: 1rem;
              margin-top: 20px;
            }
            .form-container-employee .form-column {
              margin-bottom: 1rem;
            }
            .form-container-employee .d-flex {
              flex-direction: column;
              gap: 0.5rem;
            }
            

            /* Hero content */
            .content-left {
              text-align: center;
            }
            .content-left h1 {
              font-size: 1.5rem;
              line-height: 1.4;
            }
            .content-left p {
              font-size: 0.95rem;
            }

            /* Discover section */
            .highlight-title {
              text-align: center;
              font-size: 1.2rem;
            }
            .paragraph {
              text-align: justify;
              font-size: 0.95rem;
            }
            .discover img {
              width: 100%;
              height: auto;
            }

            /* Testimonial carousel */
            .author-wrapper {
              flex-direction: column;
              text-align: center;
              gap: 1rem;
            }
            .author-img-wrapper {
              margin-bottom: 1rem;
            }
            .testimonial-content {
              font-size: 0.95rem;
              padding: 0 1rem;
            }
            .quote-icon-start,
            .quote-icon-end {
              display: none; /* hide quotes on small screens */
            }

            /* Logos slider */
            .logos .header {
              text-align: center;
              font-size: 1.2rem;
              margin-bottom: 1rem;
            }
            .logo-slider .logo-track {
              display: flex;
              flex-wrap: wrap;
              justify-content: center;
              gap: 1rem;
            }
            .logo-slider img {
              max-width: 120px;
              height: auto;
            }
          }
        `}
      </style>
    </>
  );
};

export default Employers;
